import { createRouter, createWebHistory } from 'vue-router';
import HomePageVue from '@/pages/HomePage.vue';
import SustainabilityVue from '@/pages/Sustainability.vue';
import CompanyVue from '@/pages/Company.vue';
import CareersVue from '@/pages/Careers.vue';
import PartnershipProgramVue from '@/pages/PartnershipProgram.vue';
import LearnWhyVue from '@/pages/LearnWhy.vue';

const routes = [
  { path: '/', component: HomePageVue },
  { path: '/sustainability', component: SustainabilityVue },
  { path: '/company', component: CompanyVue },
  { 
    path: '/careers', 
    component: CareersVue,
    beforeEnter: (to, from, next) => {
      window.scrollTo(0, 0);
      next(); 
    }
  },
  { path: '/partnershipProgram', component: PartnershipProgramVue },
  { path: '/learnWhy', component: LearnWhyVue }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else {
      return { top: 0, behavior: 'smooth' };
    }
  },
});

export default router;
